import { render } from "./TeachingPage.vue?vue&type=template&id=41307e02&scoped=true"
import script from "./TeachingPage.vue?vue&type=script&lang=js"
export * from "./TeachingPage.vue?vue&type=script&lang=js"

import "./TeachingPage.vue?vue&type=style&index=0&id=41307e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41307e02"]])

export default __exports__